module.exports = __webpack_public_path__ + "static/media/paperPlane.1e5a356d.svg";